(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/game-handler/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/ticketgames/game-handler/assets/javascripts/utils.js');

let mapProductType;
if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  const ticketMappings = trinidad.components.require('ticketgames', 'ticket-mappings');
  mapProductType = ticketMappings.mapProductType;
} else {
  mapProductType = svs.ticketgames.ticketMappings.productMappings.mapProductType;
}

function ticketMatchesTicketType(ticket, ticketType) {
  return ticket.type === ticketType?.toLowerCase?.();
}

function ticketMatchesProductType(ticket, ticketType) {
  const productType = mapProductType(ticket.type);
  if (productType === 'trissadventskalender' && ticketType?.toLowerCase?.() === 'trissadventskalender150') {
    return true;
  }
  return productType === ticketType?.toLowerCase?.();
}

function getFirstAffordableTicket(availableTickets, winningAmount) {
  return availableTickets.find((ticket) => ticket.price <= winningAmount);
}

function getTicketInfoByTicketType(ticketType, availableTickets, winningAmount) {
  let ticketInfo = availableTickets.find((ticket) => ticketMatchesTicketType(ticket, ticketType));
  if (!ticketInfo) {
    ticketInfo = availableTickets.find((ticket) => ticketMatchesProductType(ticket, ticketType));
  }
  if (winningAmount && ticketInfo && ticketInfo.price > winningAmount) {
    if (getFirstAffordableTicket(availableTickets, winningAmount)) {
      return undefined;
    }
  }
  return ticketInfo;
}

function getFallbackTicket(fallbackTicketType, availableTickets) {
  const fallbackTicket = availableTickets.find((ticket) => ticket.type === fallbackTicketType);
  if (!fallbackTicket) {
    return availableTickets[0];
  }
  return fallbackTicket;
}

function getFallbackTicketTypeParam(fallbackTicketType, availableTickets, winningAmount = 0) {
  let fallbackTicket = getFallbackTicket(fallbackTicketType, availableTickets);
  if (winningAmount && fallbackTicket.price > winningAmount) {
    const affordableTicket = getFirstAffordableTicket(availableTickets, winningAmount);
    if (affordableTicket) {
      fallbackTicket = affordableTicket;
    }
  }
  const productType = mapProductType(fallbackTicket.type);
  const numberOfMatchingTickets = availableTickets.filter((ticket) => ticketMatchesProductType(ticket, productType)).length;
  if (numberOfMatchingTickets === 1 || availableTickets[0] == fallbackTicket) {
    return productType;
  }
  return fallbackTicket.type;
}

function queryMapToString(queryMap) {
  const queryString = Object.keys(queryMap)
    .filter((key) => queryMap[key] !== undefined && queryMap[key] !== null && queryMap[key] !== '')
    .map((key) => `${key}=${encodeURIComponent(queryMap[key])}`)
    .join('&');
  return queryString ? `?${queryString}` : '';
}

const LeiaGameStatus = Object.freeze({
  OPEN: 'OPEN',
  CLOSED: 'CLSD',
  SUSPENDED: 'SSPD'
});

const LeiaEngineCode = Object.freeze({
  ITG: 'ITG', 
  MTR: 'MTR', 
  MTP: 'MTP', 
  EIN: 'EIN' 
});

function buildLeiaGameCatalogQuery(filter = { engineCode: '', status: '' }) {
  const validFilter = {};
  if (Object.values(LeiaEngineCode).includes(filter?.engineCode)) {
    validFilter.engineCode = filter.engineCode;
  }
  if (Object.values(LeiaGameStatus).includes(filter?.status)) {
    validFilter.status = filter.status;
  }
  return queryMapToString(validFilter);
}

if (svs.isServer) {
  module.exports = {
    getTicketInfoByTicketType,
    getFallbackTicket,
    getFallbackTicketTypeParam,
    queryMapToString,
    LeiaGameStatus,
    LeiaEngineCode,
    buildLeiaGameCatalogQuery
  };
} else {
  setGlobal('svs.ticketgames.gameHandler.utils', {
    getTicketInfoByTicketType,
    getFallbackTicket,
    getFallbackTicketTypeParam,
    queryMapToString,
    LeiaGameStatus,
    LeiaEngineCode,
    buildLeiaGameCatalogQuery
  });
}


 })(window);